var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"settings-title"},[_vm._v("\n    Connect WhatsApp Account\n  ")]),_c('div',{staticClass:"settings-form"},[_vm._v("\n    Coming soon\n  ")])])
}]

export { render, staticRenderFns }